import { render, staticRenderFns } from "./GridContainer.vue?vue&type=template&id=ec2a3934&"
import script from "./GridContainer.vue?vue&type=script&lang=js&"
export * from "./GridContainer.vue?vue&type=script&lang=js&"
import style0 from "./GridContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports